import classNames from "classnames";
import { type CSSProperties, useMemo } from "react";

import classes from "./Stacker.module.less";

type Props = JSX.IntrinsicElements["div"] & {
  gap: number;
  direction?: "row" | "column";
};

/**
 * @deprecated - use mui Stack instead
 */
export const Stacker = ({ gap, direction = "column", className, style, ...rest }: Props) => (
  <div style={useStyle(gap, direction, style)} className={classNames(classes.root, className)} {...rest} />
);

function useStyle(gap: Props["gap"], direction: "row" | "column", style: CSSProperties | undefined): CSSProperties {
  return useMemo(
    () =>
      ({
        "--stacker-gap": gap + "px",
        "--stacker-direction": direction,
        ...(style ?? {}),
      }) as CSSProperties,
    [gap, direction, style],
  );
}
